import {Component} from "@angular/core";

@Component({
  selector: "page-not-found",
  template: "<h1>Page not found.</h1>",
})

export class PageNotFoundComponent {
  constructor() {
  }
}
